'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSmoothCollapse = require('react-smooth-collapse');

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _light = require('react-syntax-highlighter/dist/light');

var _light2 = _interopRequireDefault(_light);

var _javascript = require('highlight.js/lib/languages/javascript');

var _javascript2 = _interopRequireDefault(_javascript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _light.registerLanguage)('javascript', _javascript2.default);

var CodeExample = function (_Component) {
  _inherits(CodeExample, _Component);

  function CodeExample() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CodeExample);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CodeExample.__proto__ || Object.getPrototypeOf(CodeExample)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: _this.props.initialOpen
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CodeExample, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var code = this.props.code;

      var preTag = function preTag(_ref2) {
        var children = _ref2.children;
        return _react2.default.createElement(
          'pre',
          { className: 'highlight-block' },
          children
        );
      };
      var codeTag = function codeTag(_ref3) {
        var children = _ref3.children;
        return _react2.default.createElement(
          'code',
          { className: 'hljs javascript' },
          children
        );
      };
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-md-12', style: { paddingTop: '10px' } },
          _react2.default.createElement(
            _reactSmoothCollapse2.default,
            { expanded: this.state.open },
            _react2.default.createElement(
              _light2.default,
              { language: 'javascript', useInlineStyles: false, PreTag: preTag, CodeTag: codeTag },
              code
            )
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.setState({ open: !_this2.state.open });
              }, className: 'btn btn-link pull-right' },
            this.state.open ? 'Hide code' : 'Show code'
          )
        )
      );
    }
  }]);

  return CodeExample;
}(_react.Component);

exports.default = CodeExample;


CodeExample.propTypes = {
  code: _propTypes2.default.string,
  initialOpen: _propTypes2.default.bool
};

CodeExample.defaultProps = {
  initialOpen: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/documentation/CodeExample.js
// module id = 497
// module chunks = 0